<template>
  <h6>Юридические данные</h6>
  <div style="display: flex; justify-content: center">
    <div class="left-side" style="width: 50%; padding-right: 20px;">
      <label for="companyName" style="font-weight: bold;">Название компании</label>
      <argon-input
          id="companyName"
          v-model="companyName"
          :value="companyName"
          placeholder="Название компании"
          @input="updateClientCompanyName"
      />

      <label for="authorityBasis" style="font-weight: bold;">Действующий на основании</label>
      <argon-input
          id="authorityBasis"
          v-model="authorityBasis"
          :value="authorityBasis"
          placeholder="Действующий на основании"
          @input="updateClientAuthorityBasis"
      />

      <label for="authorizedPerson" style="font-weight: bold;">Должность и ФИО</label>
      <argon-input
          id="authorizedPerson"
          v-model="authorizedPerson"
          :value="authorizedPerson"
          placeholder="Должность и ФИО"
          @input="updateClientAuthorizedPerson"
      />

      <label for="legalAddress" style="font-weight: bold;">Юридический адрес</label>
      <argon-input
          id="legalAddress"
          v-model="legalAddress"
          :value="legalAddress"
          placeholder="Юридический адрес"
          @input="updateClientLegalAddress"
      />
    </div>

    <div class="right-side" style="width: 50%; padding-left: 20px;">
      <label for="companyPhone" style="font-weight: bold;">Телефон компании</label>
      <argon-input
          id="companyPhone"
          v-model="companyPhone"
          :value="companyPhone"
          placeholder="Телефон компании"
          @input="updateClientCompanyPhone"
      />

      <label for="unpOrItn" style="font-weight: bold;">УНП (ИНН)</label>
      <argon-input
          id="unpOrItn"
          v-model="unpOrItn"
          :value="unpOrItn"
          placeholder="УНП (ИНН)"
          @input="updateClientTaxNumber"
      />

      <label for="bankAccount" style="font-weight: bold;">Банковский счет</label>
      <argon-input
          id="bankAccount"
          v-model="bankAccount"
          :value="bankAccount"
          placeholder="Банковский счет"
          @input="updateClientBankAccount"
      />

      <div class="input-container" style="margin-top: 16px; position: relative;">
        <label for="bic">БИК</label>
        <input
            id="bic"
            v-model="selectedBankBic"
            type="text"
            placeholder="Введите БИК для поиска"
            style="max-width: 100%; border: 1px solid #d2d6da; color: #495057; border-radius: 0.5rem; font-size: 0.85rem; padding: 0.5rem 0.75rem;"
            @input="filterBankBics"
            @focus="showOptions = true"
            @blur="onBlurHandler"
        >
        <ul v-if="showOptions" class="options-list">
          <li
              v-for="(bankBic, index) in filteredBics"
              :key="index"
              @click="selectBankBic(bankBic)"

          >
            {{ bankBic }}
          </li>
        </ul>
      </div>


      <div class="input-container" style="margin-bottom: 16px; margin-top: 16px;">
        <label for="invoiceDate">Дата выставления счета</label>
        <input
            id="invoiceDate"
            v-model="invoiceDate"
            type="date"
            placeholder="Дата выставления счета"
            @input="updateClientInvoiceDate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ArgonInput from "../../../components/ArgonInput.vue";

export default {
  name: 'ClientThirdStep',
  components: {ArgonInput},
  data() {
    return {
      showOptions: false,
      searchQuery: '',
      bankBics: [
        'ZEPTBY2X',
        'UNBSBY2X',
        'TECNBY22',
        'SSISBY25',
        'SLANBY22',
        'RSHNBY2X',
        'REDJBY22',
        'POISBY2X',
        'PJCBBY2X',
        'OLMPBY2X',
        'NBRBBY2X',
        'MTBKBY22',
        'MMBNBY22',
        'IRJSBY22',
        'INEARUMM',
        'EABRKZKA',
        'BRRBBY2X',
        'BPSBBY2X',
        'BLNBBY2X',
        'BLBBBY2X',
        'BISCBY25',
        'BELBBY2X',
        'BCSXBY22',
        'BBTKBY2X',
        'BAPBBY2X',
        'ALFABY2X',
        'AKBBBY2X',
        'AEBKBY2X',
        'ABIGBY25',
      ],
    };
  },
  computed: {
    companyName: {
      get() {
        return this.$store.state.clientCreateCompanyName;
      },
    },
    authorizedPerson: {
      get() {
        return this.$store.state.clientCreateAuthorizedPerson
      }
    },
    authorityBasis: {
      get() {
        return this.$store.state.clientCreateAuthorityBasis
      }
    },
    legalAddress: {
      get() {
        return this.$store.state.clientCreateLegalAddress
      }
    },
    companyPhone: {
      get() {
        return this.$store.state.clientCreateCompanyPhone
      }
    },
    unpOrItn: {
      get() {
        return this.$store.state.clientCreateTaxNumber
      }
    },
    bankAccount: {
      get() {
        return this.$store.state.clientCreateBankAccount
      }
    },
    invoiceDate: {
      get() {
        return this.$store.state.clientCreateInvoiceDate
      }
    },
    selectedBankBic: {
      get() {
        return this.$store.state.clientCreateBic
      }
    },
    filteredBics() {
      if (!this.selectedBankBic || this.selectedBankBic.trim() === '') {
        return this.bankBics;
      } else {
        return this.bankBics.filter((bankBic) =>
            bankBic.toLowerCase().includes(this.selectedBankBic.toLowerCase())
        );
      }
    },

  },
  methods: {

    onBlurHandler() {
      setTimeout(() => {
        this.showOptions = false;
      }, 200);
    },

    updateClientCompanyName(payload) {
      this.$store.commit('updateClientCreateCompanyName', payload.target.value);
    },
    updateClientAuthorizedPerson(payload) {
      this.$store.commit('updateClientCreateAuthorizedPerson', payload.target.value);
    },
    updateClientAuthorityBasis(payload) {
      this.$store.commit('updateClientCreateAuthorityBasis', payload.target.value);
    },
    updateClientLegalAddress(payload) {
      this.$store.commit('updateClientCreateLegalAddress', payload.target.value);
    },
    updateClientCompanyPhone(payload) {
      this.$store.commit('updateClientCreateCompanyPhone', payload.target.value);
    },
    updateClientTaxNumber(payload) {
      this.$store.commit('updateClientCreateTaxNumber', payload.target.value);
    },
    updateClientBankAccount(payload) {
      this.$store.commit('updateClientCreateBankAccount', payload.target.value);
    },
    updateClientInvoiceDate(payload) {
      this.$store.commit('updateClientInvoiceDate', payload.target.value);
    },
    updateClientSelectedBankBic(payload) {
      this.$store.commit('updateClientCreateBankBic', payload.target.value);
    },
    filterBankBics(payload) {
      this.$store.commit('updateClientCreateBankBic', payload.target.value);
      this.showOptions = true;
    },
    selectBankBic(bankBic) {
      this.$store.commit('updateClientCreateBankBic', bankBic);
      this.showOptions = false;
    },
  }
}
</script>

<style scoped>

#invoiceDate {
  border: 1px solid #d2d6da;
  color: #495057;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
}

.input-container {
  display: flex;
  flex-direction: column;
}
.options-list {
  position: absolute;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  padding-left: 0;
  border: 1px solid #d2d6da;
  border-radius: 0.5rem;
  background-color: white;
  z-index: 1;
  top: 100%; /* Добавьте эту строку */
  margin-top: 0.25rem;
}

.options-list li {
  padding: 0.5rem 0.5rem;
  cursor: pointer;
  list-style-type: none;
}

.options-list li:hover {
  background-color: #f8f9fa;
}

</style>
